import useTeam from "@/hooks/useTeam";
import { Buttons } from "@/ui/Buttons";
import { Carousel } from "@/ui/Carousel";
import { ParallaxBackground } from "@/ui/ParallaxBackground";
import { TeamMemberCard } from "@/ui/TeamMemberCard";
import cn from "classnames";
import { Col, Container, Row } from "react-bootstrap";

import bg_1 from "./bg_1.webp";
import bg_2 from "./bg_2.webp";
import classes from "./styles.module.scss";

// Above this many consultants the grid switches to a carousel.
const GRID_LIMIT = 4;

export default function ({
  className = "py-5 py-md-6",
  title,
  description,
  buttons = [{ label: "View All Team", url: "/about-us/meet-team", variant: "blue" }],
  prefix,
  EditableText,
  EditableHtml,
  theme = "light",
  __sector,
}) {
  const team = useTeam({ __sector });

  // Hide the block until at least one consultant is tagged with this sector.
  if (!__sector || team.length === 0) return null;

  return (
    <div className={cn(className, classes.SectorTeam)} data-bs-theme={theme}>
      <ParallaxBackground anim="y1:x0:z0" image={bg_1} className={classes.bg_1} />
      <ParallaxBackground anim="y2:x2:z0" image={bg_2} className={classes.bg_2} />
      <Container fluid="lg">
        <div className="text-center mb-4">
          <EditableText path="title" tag="h2">
            <span dangerouslySetInnerHTML={{ __html: title }} />
          </EditableText>
          <EditableHtml path="description" className="text-xl">
            <div dangerouslySetInnerHTML={{ __html: description }} />
          </EditableHtml>
        </div>
        {team.length > GRID_LIMIT ? (
          <Carousel
            className={classes.carousel}
            elementKey={`${prefix}_sector_team`}
            slidesPerView={1.6}
            autoplay={true}
            breakpoints={{
              576: { slidesPerView: 2 },
              768: { slidesPerView: 3 },
              992: { slidesPerView: 4 },
            }}
            items={team.map((member) => (
              <TeamMemberCard {...member} />
            ))}
          />
        ) : (
          <Row className="justify-content-center">
            {team.map((member) => (
              <Col key={member.id} xs={12} sm={6} md={3}>
                <TeamMemberCard {...member} />
              </Col>
            ))}
          </Row>
        )}
        <Buttons className="justify-content-center mt-4 mt-md-5" buttons={buttons} />
      </Container>
    </div>
  );
}
